import "./style.less";

export default function TableFixedPeriods() {
    return {
        restrict: "E",
        scope: {
            tableData: "<",
            searchParams: "<",
            callback: "&",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.getStatus = (period) => {
                let status = period.allowBooking ? "available" : "occupied";

                if (period._type == "dummy-period") {
                    status = "unavailable";
                }

                return status;
            };
        },
    };
}
